// src/features/dashboard/components/charts/WeeklyUsersChart/WeeklyUsersChart.jsx
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";
import SupervisorAccountRoundedIcon from "@mui/icons-material/SupervisorAccountRounded";

import BarChart from "../../../../../components/Charts/BarChart/BarChart";
import ChartWrapper from "../../../../../components/common/ChartWrapper/ChartWrapper";
import ChartHeader from "../../../../../components/common/ChartHeader/ChartHeader";
import { transformWeeklyUsersData } from "../../../utils/chartTransformers";

import "../dashboardCharts.scss";

const WeeklyUsersChart = () => {
  const { weeklyUsers, weeklyUsersFetching } = useSelector((s) => s.dashboard);
  const chartData = useMemo(
    () => transformWeeklyUsersData(weeklyUsers),
    [weeklyUsers],
  );
  const isEmpty = !chartData.labels?.length;

  return (
    <Box className="chart-card animate-card">
      <ChartHeader
        icon={SupervisorAccountRoundedIcon}
        title="Weekly Analysis of Active Users"
      />
      <ChartWrapper
        isLoading={weeklyUsersFetching}
        isEmpty={isEmpty}
        height="394px"
      >
        <BarChart data={chartData} yAxisTitle="Active Users" />
      </ChartWrapper>
    </Box>
  );
};

export default WeeklyUsersChart;
